<!-- <div  class="absolute bottom-0 left-0 z-50">
    <button
      (click)="toggleMap()"
      class="bg-primary block sm:inline-block font-bold text-white px-4 py-2 rounded animate__animated animate__fadeInTopRight animated__delay-1s"
    >
      Volver al chat
    </button>
  </div> -->
<!-- Map -->
<div *ngIf="(isMobile && !showMap) || !isMobile" @slideDownUp class="h-screen w-full md:w-6/12 relative">
  <!-- Google Map -->
  <google-map [height]="mapHeight" [width]="mapWidth" [center]="coords" [zoom]="13" [options]="mapOptions">
  <map-marker *ngIf="coords" [position]="coords" [title]="'Tu ubicación'" [icon]="userIconPosition" ></map-marker>

    <map-marker
      *ngFor="let workshop of workshops"
      [position]="workshop.coords"
      [title]="workshop.companyName"
      [icon]="workshop.icon"
      #marker="mapMarker"
      (mapClick)="openWorkshopInfo(marker, workshop)"
    ></map-marker>

    <map-info-window>
      <div class="panel h-full w-full  overflow-hidden border-0 p-0">
        <div>
          <div class="flex items-center justify-center pt-4" *ngIf="selectedWorkshop?.images!.length > 0">
            <app-workshop-photos [items]="selectedWorkshop?.images"></app-workshop-photos>
          </div>
        </div>

        <div class="">
          <!-- Nombre de la compañía y botón de agendar -->
          <div class="flex flex-col items-center mb-4">
            <div class="text-lg text-center font-bold w-full text-black dark:text-white animate__animated animate__zoomIn mb-3">
              <strong class="animate__animated animate__zoomIn w-full">{{ selectedWorkshop ? selectedWorkshop.companyName : '' }}</strong>
            </div>
            <button
              type="button"
              class="btn btn-primary text-white px-8 py-2 rounded-full animate-pulse hover:bg-primary-dark transition-colors"
              (click)="schedule(selectedWorkshop!)"
            >
              AGENDAR CITA
            </button>
          </div>

          <!-- Categoría -->
          <div class="rating-stars pl-4">
            <div class="stars-container">
              <span
                *ngFor="let star of [1, 2, 3, 4, 5]"
                class="star-icon"
                [class.filled]="selectedWorkshop && star <= selectedWorkshop.rank">
                &#9733; <!-- Unicode para una estrella -->
              </span>
              <span class="rank-text text-white" *ngIf="selectedWorkshop">
                {{ selectedWorkshop.rank  }}/5
              </span>
            </div>
          </div>

          <!-- Categorías -->
          <div class="categories-section text-black dark:text-white pl-4">
              <div class="categories-grid">
            <h3 class="font-semibold text-white">Especialidades:</h3>
              <span *ngFor="let category of selectedWorkshop?.categories" class="category-tag">
                {{ category }}
              </span>
            </div>
          </div>


          <!-- Servicios -->
          <!-- <div class="space-y-2">
            <p class="font-semibold text-[#515365]">
              Servicios:
            </p>
            <div class="flex flex-wrap gap-2">
              <span class="inline-block rounded-full bg-dark px-3 py-1 text-xs text-white animate__animated animate__fadeInDown">Cambio de aceite</span>
              <span class="inline-block rounded-full bg-dark px-3 py-1 text-xs text-white animate__animated animate__fadeInDown">Revisión de neumáticos</span>
              <span class="inline-block rounded-full bg-dark px-3 py-1 text-xs text-white animate__animated animate__fadeInDown">Inspección de suspensión</span>
              <span class="inline-block rounded-full bg-dark px-3 py-1 text-xs text-white animate__animated animate__fadeInDown">Reparación de motores</span>
            </div>
          </div> -->
        </div>
      </div>
    </map-info-window>
  </google-map>
</div>

